import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, forwardRef, input, signal } from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { sanitizeDirectusArray } from "../../../../common/utils/sanitize-directus-object";
import { ItemsAccordionBlock } from "../../../api/packbo/models/items-accordion-block";
import { DynamicPageComponent } from "../dynamic-page/dynamic-page.component";

@Component({
    selector: "packbo-accordion-block",
    templateUrl: "./accordion-block.template.html",
    imports: [DirectusTranslationPipe, SvgIconComponent, forwardRef(() => DynamicPageComponent)],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccordionBlockComponent {
    public readonly accordionBlock = input.required<ItemsAccordionBlock>();
    public readonly isLast = input(false);
    public readonly isExpanded = signal(false);

    public readonly nestedBlocks = computed(() => sanitizeDirectusArray(this.accordionBlock().blocks_refs));

    public toggleAccordion(): void {
        this.isExpanded.set(!this.isExpanded());
    }
}
